// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  InputAdornment,
  SxProps,
  TextField,
  TextFieldProps,
} from "@mui/material";
import { Theme } from "@mui/system";
import { Control, Controller, ControllerProps } from "react-hook-form";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

export type InpControlProps = {
  label: string;
  isDisabled?: boolean;
  numeric?: boolean;
  stringOnly?: boolean;
  showInfoIcon?: boolean
} & TextFieldProps;

export type InputControlProps<TFormFields> = {
  control: Control<TFormFields, object>;
  helperText?: string;
  adornmentText?: string;
  isDisabled?: boolean;
  type?: React.HTMLInputTypeAttribute | undefined;
  id: Path<TFormFields>;
  label?: string;
  numeric?: boolean;
  defaultValue?: any;
  size?: "medium" | "small";
  sx?: SxProps<Theme>;
  maxLength?: number;
  removeSpaces?: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
} & InpControlProps &
  Pick<ControllerProps, "rules">;

export function InputControl<TFormFields>(
  props: InputControlProps<TFormFields>
) {
  const {
    control,
    type,
    label,
    adornmentText,
    rules,
    tooltipText,
    numeric,
    stringOnly,
    size = "medium",
    sx,
    isDisabled,
    defaultValue,
    maxLength,
    minLength,
    removeSpaces = false,
    buttonAdornment,
    inputRef,
    ...textFieldProps
  } = props;

  return (
    <Controller
      control={control}
      name={textFieldProps.name || textFieldProps.id}
      // rules={rules}
      rules={{
        ...rules,
        maxLength: maxLength,
        minLength: minLength   // Yeni eklenen özellik
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const handleChange = (e) => {
          let inputValue = e.target.value;

          // Maksimum uzunluk kontrolü
          if (maxLength && inputValue.length > maxLength) {
            return; // Maksimum uzunluğu aşıyorsa, daha fazla girişi kabul etme
          }

          // stringOnly aktifse, yalnızca harf içeren stringleri kabul et
          if (stringOnly) {
            inputValue = inputValue.replace(/[^A-Za-zğüşıöçĞÜŞİÖÇ\s]/g, '');
            onChange(inputValue);
          } else if (numeric) {
            // Eğer numeric aktifse, yalnızca sayısal değerlere izin ver
            const numericRegex = /^[.0-9\b]+$/;
            if (inputValue === "" || numericRegex.test(inputValue)) {
              onChange(inputValue);
            } else {
              onChange(value); // Mevcut değeri koru
            }
          } else {
            // Genel durum: removeSpaces aktifse boşlukları kaldır
            if (removeSpaces) {
              inputValue = inputValue.replace(/\s/g, '');
            }
            onChange(inputValue); // Değişiklikleri uygula
          }
        };

        return (

          <TextField
            id={textFieldProps.id}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start" >
                  {adornmentText}
                  {props.showInfoIcon && (
                    <Tooltip title={tooltipText} placement="top">
                      <InfoIcon />
                    </Tooltip>
                  )}
                  {buttonAdornment}
                </InputAdornment>

              ),
            }}
            inputRef={inputRef}
            disabled={isDisabled}
            sx={sx}
            size={size}
            error={!!error}
            onChange={handleChange}
            value={value}
            type={type}
            label={label}
            variant="outlined"
            autoComplete={textFieldProps.autoComplete}
          />

        );
      }}
      defaultValue={defaultValue}
    />
  );
}
